/**
 * Automatisk tilldelning (#1653): the förvaltare's under/över decision on a
 * felanmälan from the portal. `alreadyHandled` marks the refusal for an issue
 * an admin converted/archived or that was decided meanwhile, so the portal
 * reloads.
 */
import { useCallback, useState } from 'react';
import { guestApi } from '../../../api/guestApi';
import { AssessIssueResult, IssueCostDecision } from '../../../types/guestAccess';

export class AssessIssueError extends Error {
    constructor(message: string, readonly alreadyHandled: boolean) {
        super(message);
        this.name = 'AssessIssueError';
    }
}

export const COMMENT_MAX_LENGTH = 1000;

export function useAssessIssue(token: string) {
    const [submitting, setSubmitting] = useState(false);

    const assess = useCallback(async (issueKey: string, decision: IssueCostDecision, comment: string): Promise<AssessIssueResult> => {
        setSubmitting(true);
        try {
            return await guestApi.assessIssue(token, { issueKey, decision, comment: comment.trim().slice(0, COMMENT_MAX_LENGTH) });
        } catch (err) {
            console.error('assessIssue failed', err);
            const code = (err as { code?: unknown } | null)?.code;
            const message = err instanceof Error && err.message ? err.message : 'Kunde inte spara bedömningen. Försök igen.';
            throw new AssessIssueError(message, code === 'functions/failed-precondition');
        } finally {
            setSubmitting(false);
        }
    }, [token]);

    return { assess, submitting };
}
